
export const getIncomeForm = state => state.income || {};



// WEBPACK FOOTER //
// ./src/redux/incomeForm/selectors.js